import InputButton from 'components/form/inputButton'
import React, { Component } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
type Props = {
	fileContent: string
	handleCloseModal: () => void
}

type State = {}

export default class CommonPrintModal extends Component<Props, State> {
	handlePrint = () => {
		const { fileContent } = this.props

		// Create an invisible iframe
		const iframe = document.createElement('iframe')
		iframe.style.visibility = 'hidden'
		iframe.style.position = 'absolute'
		iframe.style.width = '0'
		iframe.style.height = '0'
		iframe.style.border = '0'
		document.body.appendChild(iframe)

		const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document
		if (iframeDoc) {
			iframeDoc.open()
			iframeDoc.write(`
        <html>
          <head>
            <title>Print Content</title>
            <style>
              @media screen {
                .printable {
                  display: none;
                }
              }
              @media print {
                body * {
                  visibility: hidden;
                }
                .printable {
                  visibility: visible;
                  position: absolute;
                  top: 0;
                  left: 0;
                  /* Additional print-specific styles */
                }
              }
            </style>
          </head>
          <body>
            <div class="printable">${fileContent}</div>
          </body>
        </html>
      `)
			iframeDoc.close()
		}

		iframe.onload = () => {
			iframe.contentWindow?.focus()
			iframe.contentWindow?.print()
			document.body.removeChild(iframe) // Clean up the iframe after printing
			this.props.handleCloseModal()
		}
	}

	render() {
		return (
			<Container>
				<Row className="text-center">
					{/* Button to trigger printing */}
					<Col>
						<InputButton
							valueButton={'Imprimir'}
							onClick={this.handlePrint}
							type={'primary'}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>

					<Col>
						<InputButton
							valueButton={'Cancelar'}
							onClick={this.props.handleCloseModal}
							type={'primary'}
							customStyle={{ minWidth: '145px' }}
						/>
					</Col>
				</Row>
			</Container>
		)
	}
}
